import { React, useState } from "react";
import { useParams } from "react-router-dom";
import Nav from "../components/Nav";
import * as axios from "axios";
import { default as config } from "../config.json";
import Footer from "../components/Footer";
import { decodeToken } from "react-jwt";
import { Link } from "react-router-dom";

export default function AddBio() {
  const [bio, setBio] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  let isLoggedIn;
  if (localStorage.getItem("token")) {
    isLoggedIn = true;
  }
  const uuid = decodeToken(localStorage.getItem("token")).uuid;
  async function addBio() {
    await axios
      .post(`${config.api_base_url}/api/dashboard/addBio`, {
        bio: bio,
        id: uuid,
      })
      .then((res) => {
        setError("");
        setSuccess(res.data.success);
        console.log(res);
      })
      .catch(function (error) {
        console.log(error);
        setSuccess("");
        setError(error.response.data.error);
      });
  }
  return (
    <>
      <Nav loggedIn={isLoggedIn} />
      <div className="flex justify-center w-full h-screen bg-gray-100">
        <div>
          <input
            type="text"
            name="bio"
            id="bio"
            className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-2"
            placeholder={bio ? bio : "Your Bio"}
            onChange={(e) => {
              setBio(e.target.value);
            }}
            required
          />
          <button
            className="inline-flex transition ease-in-out text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg mt-2"
            onClick={addBio}
          >
            Add Bio
          </button>
          <Link to="/dashboard">
            <button className="inline-flex transition ease-in-out text-white bg-gray-400 border-0 py-2 px-6 focus:outline-none hover:bg-gray-500 rounded text-lg mt-2 ml-2">
              Go back
            </button>
          </Link>
          {error && <p className="text-red-500 text-xs italic">{error}</p>}
          {success && (
            <p className="text-green-500 text-xs italic">{success}</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
